import React from 'react';
import PropTypes from 'prop-types';
import { getFilterNameByType } from 'utils';
import Filter from './Filter';

import './style.scss';

const FiltersGroup = ({
  filterGroup,
  selectedFilters,
  setFilters,
  onSelectChange,
  withoutHr,
}) => (
  <div className="filters-group">
    <span className="filters-group__caption">{getFilterNameByType(filterGroup[0].type)}</span>
    {filterGroup.map(filter =>
      <Filter
        key={filter.id}
        groupId={filterGroup[0].type}
        selectedFilters={selectedFilters}
        setFilters={setFilters}
        onSelectChange={onSelectChange}
        {...filter}
      />)}
    {!withoutHr && <hr className="filters-group__hr" />}
  </div>
);

FiltersGroup.propTypes = {
  filterGroup: PropTypes.array.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  withoutHr: PropTypes.bool,
};

FiltersGroup.defaultProps = {
  withoutHr: false,
};

export default FiltersGroup;



// WEBPACK FOOTER //
// ./src/components/ui/FiltersContainer/FiltersGroup/index.js